import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { MenuButton } from '../components/NavigationMenu';

const PoliticaPrivacidadPage = () => {
  return (
    <div className="min-h-screen bg-[#1a2b3c] text-[#f5f5dc]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#1a2b3c]/95 backdrop-blur-sm border-b border-[#50c878]/20">
        <div className="flex items-center justify-between px-4 py-3">
          <div className="flex items-center gap-3">
            <MenuButton />
            <Link 
              to="/" 
              className="flex items-center gap-2 text-[#f5f5dc]/60 hover:text-[#f5f5dc] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm hidden sm:inline">Volver</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="pt-20 pb-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-12 h-12 rounded-full bg-[#50c878]/20 flex items-center justify-center">
            <Shield className="w-6 h-6 text-[#50c878]" />
          </div>
          <h1 className="text-3xl sm:text-4xl font-cinzel text-[#f5f5dc]">Política de Privacidad</h1>
        </div>

        <div className="prose prose-invert max-w-none space-y-6">
          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">1. ¿Quién es el Responsable del Tratamiento de sus Datos?</h2>
            <ul className="space-y-2 text-[#f5f5dc]/70">
              <li><strong className="text-[#f5f5dc]">Identidad:</strong> Versión Digital S.L.</li>
              <li><strong className="text-[#f5f5dc]">C.I.F.:</strong> B98660459</li>
              <li><strong className="text-[#f5f5dc]">Dirección:</strong> Calle Martínez Ferrando 6, CD. 46004, Valencia</li>
              <li><strong className="text-[#f5f5dc]">Correo electrónico:</strong> administracion@versiondigital.es</li>
            </ul>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">2. ¿Con qué Finalidad Tratamos sus Datos Personales?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              En www.amagnificentlife.es tratamos la información que nos facilitan las personas interesadas con las siguientes finalidades:
            </p>
            <ul className="space-y-3 text-[#f5f5dc]/70">
              <li>
                <strong className="text-[#f5f5dc]">Gestión de consultas:</strong> Atender las solicitudes de información recibidas a través de los formularios de contacto o correos electrónicos.
              </li>
              <li>
                <strong className="text-[#f5f5dc]">Comunicaciones comerciales:</strong> Siempre que contemos con su consentimiento explícito, enviar boletines informativos (newsletters) sobre la programación de óperas, ballets, conciertos y novedades de Versión Digital.
              </li>
              <li>
                <strong className="text-[#f5f5dc]">Cumplimiento legal:</strong> Cumplir con las obligaciones legales y tributarias derivadas de nuestra actividad comercial.
              </li>
            </ul>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">3. ¿Por Cuánto Tiempo Conservaremos sus Datos?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              Los datos personales proporcionados se conservarán:
            </p>
            <ul className="space-y-2 text-[#f5f5dc]/70 list-disc list-inside">
              <li>Mientras se mantenga la relación mercantil o de servicios.</li>
              <li>Hasta que el interesado solicite su supresión o retire su consentimiento.</li>
              <li>Durante los plazos legales obligatorios (fiscales y contables) una vez finalizada la relación.</li>
            </ul>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">4. ¿Cuál es la Legitimación para el Tratamiento de sus Datos?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              La base legal para el tratamiento de sus datos depende de la finalidad:
            </p>
            <ul className="space-y-2 text-[#f5f5dc]/70">
              <li>
                <strong className="text-[#f5f5dc]">Consentimiento del interesado:</strong> Para el envío de comunicaciones comerciales y respuesta a consultas web.
              </li>
              <li>
                <strong className="text-[#f5f5dc]">Interés legítimo:</strong> Para la seguridad del sitio web y marketing directo a clientes actuales de la empresa.
              </li>
            </ul>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">5. ¿A qué Destinatarios se Comunicarán sus Datos?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              Versión Digital S.L. no cederá sus datos a terceros, salvo en los siguientes casos:
            </p>
            <ul className="space-y-2 text-[#f5f5dc]/70">
              <li>
                <strong className="text-[#f5f5dc]">Obligación legal:</strong> A las Administraciones Públicas y autoridades competentes.
              </li>
              <li>
                <strong className="text-[#f5f5dc]">Proveedores de servicios:</strong> Empresas encargadas del tratamiento de datos que prestan servicios técnicos (hosting, CRM, plataformas de envío de email) y que cumplen con los estándares de seguridad exigidos por el RGPD.
              </li>
            </ul>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">6. ¿Cuáles son sus Derechos al Facilitarnos sus Datos?</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed mb-4">
              Usted tiene derecho a obtener confirmación sobre si en Versión Digital S.L. estamos tratando datos personales que les conciernan, o no. Los interesados tienen derecho a:
            </p>
            <ul className="space-y-2 text-[#f5f5dc]/70">
              <li><strong className="text-[#f5f5dc]">Acceso:</strong> Saber qué datos tratamos.</li>
              <li><strong className="text-[#f5f5dc]">Rectificación:</strong> Corregir datos inexactos.</li>
              <li><strong className="text-[#f5f5dc]">Supresión ("Olvido"):</strong> Solicitar la eliminación de sus datos.</li>
              <li><strong className="text-[#f5f5dc]">Oposición:</strong> Dejar de recibir comunicaciones comerciales.</li>
              <li><strong className="text-[#f5f5dc]">Limitación del tratamiento:</strong> Solicitar el bloqueo temporal del tratamiento en casos específicos.</li>
              <li><strong className="text-[#f5f5dc]">Portabilidad:</strong> Recibir sus datos en un formato electrónico estructurado.</li>
            </ul>
            <p className="text-[#f5f5dc]/70 leading-relaxed mt-4">
              Para ejercer estos derechos, puede enviar una comunicación por escrito al domicilio social de Versión Digital S.L. o al correo electrónico <a href="mailto:administracion@versiondigital.es" className="text-[#50c878] hover:underline">administracion@versiondigital.es</a>, adjuntando copia de su DNI o documento equivalente para verificar su identidad.
            </p>
            <p className="text-[#f5f5dc]/70 leading-relaxed mt-4">
              Si considera que sus derechos no han sido debidamente atendidos, tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) en{' '}
              <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-[#50c878] hover:underline">www.aepd.es</a>.
            </p>
          </section>

          <section className="bg-[#0d1620] rounded-xl p-6 border border-[#50c878]/20">
            <h2 className="text-xl font-semibold text-[#f5f5dc] mb-4">7. Seguridad de los Datos</h2>
            <p className="text-[#f5f5dc]/70 leading-relaxed">
              Versión Digital S.L. se compromete al cumplimiento de su obligación de secreto de los datos de carácter personal y de su deber de guardarlos, y adoptará las medidas técnicas y organizativas necesarias para evitar su alteración, pérdida, tratamiento o acceso no autorizado.
            </p>
          </section>

          <section className="bg-[#50c878]/10 rounded-xl p-6 border border-[#50c878]/30">
            <h2 className="text-lg font-semibold text-[#f5f5dc] mb-3">Información Adicional</h2>
            <div className="text-[#f5f5dc]/70 text-sm space-y-2">
              <p><strong className="text-[#f5f5dc]">Responsable:</strong> Versión Digital S.L.</p>
              <p><strong className="text-[#f5f5dc]">Finalidad:</strong> Gestionar su solicitud.</p>
              <p><strong className="text-[#f5f5dc]">Derechos:</strong> Acceso, rectificación y supresión enviando email a administracion@versiondigital.es</p>
              <p className="mt-4 text-[#f5f5dc]/60">
                El sitio web www.amagnificentlife.es cuenta con certificado SSL (HTTPS) activo para el tratamiento seguro de datos personales.
              </p>
            </div>
          </section>
        </div>

        <p className="mt-8 text-[#f5f5dc]/40 text-sm text-center">
          Última actualización: Marzo 2026
        </p>
      </main>
    </div>
  );
};

export default PoliticaPrivacidadPage;
